/* eslint-disable vue/no-unused-vars */
<template>
	<v-data-table
		:headers="dataTable.headers"
		:items="dados"
		:search="dataTable.search"
		:items-per-page="5"
		:multi-sort="dataTable.multiSort"
		:loading="dataTable.loading"
		loading-text="Carregando dados..."
		:sortBy="dataTable.sortBy"
		:sortDesc="dataTable.sortDesc"
		dark
	>
		<template v-slot:item.show="{ item, header }">
			<slot name="show" :item="item" :header="header.text"></slot>
		</template>

		<template v-slot:item.link="{ item }">
			<a href="#">{{ item.link }}</a>
		</template>

		<template v-slot:item.actions="{ item }">
			<slot name="actions" :item="item"></slot>
		</template>
		
		<template v-slot:no-data>
			<p class="subtitle-1 mt-3">Sem dados cadastrados</p>
		</template>
	</v-data-table>
</template>

<script>
export default {
	inheritAttrs: false,
	// Pegando dados dos atributos non-prop
	// this.$attrs.numProp
	props: {
		dados: Array,
		dataTable: Object
	},
	// methods: {
	// 	editItemComp(item) {
	// 		this.$emit('editItem', item)
	// 	}
	// }
	// Na chamada do component
	// @editItem="editItem"
}
</script>